import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { WebLandingPageComponent } from './web-landing-page/web-landing-page.component';
import { NewLandingWebComponent } from './new-landing-web/new-landing-web.component';
import { DeeplinkMBComponent } from './deeplink-mb/deeplink-mb.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'loa-thanh-toan',
        pathMatch: 'full'
    },
    {
        path: 'loa-thanh-toan',
        component: WebLandingPageComponent
    },
    // {
    //     path: 'landing-web',
    //     component: NewLandingWebComponent
    // },
    {
        path: 'miniapp',
        component: DeeplinkMBComponent
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AuthRoutingModule { }
